import React from 'react';
import { BarChart3, Users, UserPlus, CreditCard, Trophy, Key, Download } from 'lucide-react';

const TABS = [
  { id: 'overview', label: 'Overview', icon: BarChart3 },
  { id: 'members', label: 'Members', icon: Users },
  { id: 'invite', label: 'Invite', icon: UserPlus },
  { id: 'billing', label: 'Billing', icon: CreditCard },
  { id: 'leaderboard', label: 'Leaderboard', icon: Trophy },
  { id: 'sso', label: 'SSO', icon: Key },
  { id: 'reports', label: 'Reports', icon: Download },
];

export const CampusTabs = ({ activeTab, onChange }) => (
  <div className="flex gap-2 border-b border-[var(--isp-glass-border)] pb-2 overflow-x-auto">
    {TABS.map(tab => {
      const isActive = activeTab === tab.id;
      const cls = isActive
        ? 'bg-purple-500/20 text-purple-400 border border-purple-500/30'
        : 'text-[var(--isp-body)] hover:text-[var(--isp-heading)]';
      return (
        <button
          key={tab.id}
          onClick={() => onChange(tab.id)}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm whitespace-nowrap ${cls}`}
          data-testid={`tab-${tab.id}`}
        >
          <tab.icon className="w-4 h-4" /> {tab.label}
        </button>
      );
    })}
  </div>
);
